import { openDayTime as de } from "./de.openDayTime";
import { openDayTime as en } from "./en.openDayTime";
export const CoreOpenDayTime: object = { "de": de, "en": en };
